import { client } from '../http';

export default async function getCities() {
  const response = await client.get('/api/cities');
  return response.data;
}
